


export default class ComputeService 
{

  
  private initialized = false;
 
  constructor()
  {
  }
 

  async init()
  {
    if (this.initialized) return;

     this.initialized = true;
  }
 

}